import { AuthenticationMethod, Platform } from "src/app/models/api/common";

export function arePlatformActionsAllowed(platform: Platform, authMethod: AuthenticationMethod) {
    switch (platform) {
        case Platform.powerplatform:
        case Platform.salesforce:
        case Platform.chatGptEnterprise:
            return true;
        case Platform.workato:
            return authMethod == AuthenticationMethod.apikey || authMethod == AuthenticationMethod.apitoken;
        default:
            return false;
    }
}
